



























import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class ObjTextSelected extends Vue {
    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
}
